import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

export interface EventTicketConfirmDialogData {
  header: string
  description: string
  confirmButtonText: string
  cancelButtonText: string
}

@Component({
  selector: 'gb-event-ticket-confirm-dialog',
  templateUrl: './gb-event-ticket-confirm-dialog.component.html',
  styleUrls: ['./gb-event-ticket-confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbEventTicketConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: EventTicketConfirmDialogData) {}
}
